import React from "react";
import data from "../Data.json";
import { Link } from "react-router-dom";
import Products from "./Products";

function Shop() {
  return (
    <div className="">
      <div className="products py-10 xl:px-32 lg:px-24 md:px-16 px-10  ">
        <h2 className="text-center underline uppercase xl:text-4xl lg:text-3xl md:text-2xl text-xl font-semibold pb-5">
          deals in
        </h2>
        <div className="grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 md:items-start items-center gap-4 w-full  md:px-16 px-5 ">
          {data.map((product, index) => {
            return (
              <div className="" key={index}>
                <Link to={`/product/${product.id}`}>
                  <Products
                    img={product.img}
                    title={product.title}
                    desc={product.desc}
                    price={product.price}
                    item={product}
                    detail={product.detail}
                  />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Shop;
